import { ReasonDtoDropdownItem } from "../dto";
import { Api, getCompanyId } from "../helpers";

export class ReasonApi {
  static async bookingApprovalDropdownItems(
    reasonCategoryId?: number,
  ): Promise<ReasonDtoDropdownItem[] | undefined> {
    const requestUrl = `/api/v1/core/c/${getCompanyId()}/reasons/booking_approval_dropdown_items`;
    const response = await Api.get<ReasonDtoDropdownItem[]>(
      requestUrl,
      reasonCategoryId
        ? {
            reasonCategoryId,
          }
        : undefined,
    );

    return response?.data;
  }
}
